import { render, staticRenderFns } from "./poetry_list.vue?vue&type=template&id=73b1f261&"
import script from "./poetry_list.vue?vue&type=script&lang=js&"
export * from "./poetry_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports